module.exports = __webpack_public_path__ + "static/img/nf.cd9f178.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/nf.jpg
// module id = JFeV
// module chunks = 49